/*
         * @ngdoc function
         * @name ePay.Model:Session_CreditCardsModel
         * @description
         * Model
         */
import { Session_CardModel } from './Session_CardModel';

export class Session_CreditCardsModel {
	cards: Session_CardModel[];

	constructor(
		cards?: Session_CardModel[]
	) {
		this.cards = cards || [];
	}
}
